import { Box, IconButton, Input } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ArrowRightSmall, Search as SearchIcon } from '@wix/wix-ui-icons-common';
import React, { FC, MutableRefObject, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TLocalesKeys } from '../../../../types';

type SearchProps = {
  onClear: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  searchRef: MutableRefObject<HTMLInputElement | null>;
  searchedText: string;
};

export const Search: FC<SearchProps> = ({ onClear, onChange, onSearch, searchRef, searchedText }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const querySearchParam = searchParams.get('query');
  const [showClearButton, setShowClearButton] = useState(searchedText === querySearchParam);

  useEffect(() => {
    setShowClearButton(searchedText === querySearchParam);
  }, [searchedText, querySearchParam]);

  return (
    <Input
      inputRef={(inputRef) => (searchRef.current = inputRef)}
      border="round"
      size="medium"
      autoFocus={true}
      onChange={onChange}
      placeholder={t<TLocalesKeys>('widget-search-placeholder')}
      prefix={
        <Input.IconAffix>
          <SearchIcon />
        </Input.IconAffix>
      }
      suffix={
        !showClearButton && (
          // Cannot use IconAffix since it doesn't apply width & height attributes to svg icon which causes bug in
          // safari. Thus changed to Box.
          <Box verticalAlign="middle">
            <IconButton size="tiny" onClick={onSearch}>
              <ArrowRightSmall />
            </IconButton>
          </Box>
        )
      }
      onEnterPressed={onSearch}
      value={searchedText}
      clearButton={showClearButton}
      onClear={showClearButton ? onClear : undefined}
    />
  );
};
